"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Price/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value");

function render(input, out, __component, component, state) {
  var data = input;

  out.e(input.crossout ? "s" : "span", {
      "class": marko_classValue(input.class),
      style: "color:inherit;white-space:nowrap"
    }, "0", component, 1, 1)
    .t(window.formatAmount(input.amount, input.currency), component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
